module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c05560c347359cf80b955e5ade228e61.png";